import { Component, Input } from '@angular/core';
import { RoleMatrix } from '../../../../helpers';

@Component({
    selector: 'app-breacrumb-company-user-detail',
    templateUrl: './breadcrumb.company.user.detail.component.html'
})

export class BreadcrumbCompanyUserDetailComponent {
    roleMatrix: RoleMatrix;

    @Input() companyId: number;
    @Input() filteredUserType: string;

    constructor() {
        this.roleMatrix = new RoleMatrix();
    }
}

